import { SvgIcon, SvgIconProps } from '@mui/material';

export const NavigationArrowRightIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="22"
    height="16"
    viewBox="0 0 22 16"
    sx={{ fill: 'none', stroke: 'black' }}
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.00195 7.99951L19.002 7.99951"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 14.9995L20 7.99951L13 0.999512"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
